// 通知模块统一导出

import { useEffect } from "react";
import { useUserDataFlattened } from "../user";
import { useNotificationStore } from "./stores";

// 导出类型定义
export * from "./types";

// 导出store（推荐使用）
export * from "./stores";

// 导出上下文
export * from "./contexts";

// 导出API（如果需要直接调用）
export { notificationApi } from "./api";

/**
 * 消息通知 Hook
 * 只监听 noticeUpdateTime 变化，变化时自动调用 store 中的 setUserNoticeUpdateTime
 * 所有业务逻辑都在 store 中处理
 */
export function useMessageNotification() {
  const { noticeUpdateTime } = useUserDataFlattened();
  const {
    messageUnreadCount,
    setUserNoticeUpdateTime,
    loadMessageUnreadCount,
  } = useNotificationStore();

  // 只监听 noticeUpdateTime 变化，通知 store 更新
  useEffect(() => {
    if (noticeUpdateTime !== undefined) {
      setUserNoticeUpdateTime(noticeUpdateTime);
    }
  }, [noticeUpdateTime, setUserNoticeUpdateTime]);

  return {
    messageUnreadCount,
    refresh: loadMessageUnreadCount,
  };
}
